/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AssetTypeSubsystemComponentClassComponentTypeResponseDto,
  CreateAssetTypeSubsystemComponentClassComponentTypeRequestDto,
  GetAllMappingRes,
} from '../models/index';
import {
    AssetTypeSubsystemComponentClassComponentTypeResponseDtoFromJSON,
    AssetTypeSubsystemComponentClassComponentTypeResponseDtoToJSON,
    CreateAssetTypeSubsystemComponentClassComponentTypeRequestDtoFromJSON,
    CreateAssetTypeSubsystemComponentClassComponentTypeRequestDtoToJSON,
    GetAllMappingResFromJSON,
    GetAllMappingResToJSON,
} from '../models/index';

export interface AssetSubsystemComponentClassComponentTypeControllerFindByIdRequest {
    id: string;
}

export interface AssetSubsystemComponentClassComponentTypeControllerUpdateMappingRequest {
    mappingId: string;
    createAssetTypeSubsystemComponentClassComponentTypeRequestDto: CreateAssetTypeSubsystemComponentClassComponentTypeRequestDto;
}

/**
 * 
 */
export class KnowledgeBaseAssetSubsystemComponentClassComponentTypeMappingsApi extends runtime.BaseAPI {

    /**
     */
    async assetSubsystemComponentClassComponentTypeControllerFindAllRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAllMappingRes>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/asset-subsystem-componentclass-component-type`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetAllMappingResFromJSON(jsonValue));
    }

    /**
     */
    async assetSubsystemComponentClassComponentTypeControllerFindAll(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAllMappingRes> {
        const response = await this.assetSubsystemComponentClassComponentTypeControllerFindAllRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async assetSubsystemComponentClassComponentTypeControllerFindByIdRaw(requestParameters: AssetSubsystemComponentClassComponentTypeControllerFindByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssetTypeSubsystemComponentClassComponentTypeResponseDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling assetSubsystemComponentClassComponentTypeControllerFindById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/asset-subsystem-componentclass-component-type/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AssetTypeSubsystemComponentClassComponentTypeResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async assetSubsystemComponentClassComponentTypeControllerFindById(requestParameters: AssetSubsystemComponentClassComponentTypeControllerFindByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssetTypeSubsystemComponentClassComponentTypeResponseDto> {
        const response = await this.assetSubsystemComponentClassComponentTypeControllerFindByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async assetSubsystemComponentClassComponentTypeControllerUpdateMappingRaw(requestParameters: AssetSubsystemComponentClassComponentTypeControllerUpdateMappingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['mappingId'] == null) {
            throw new runtime.RequiredError(
                'mappingId',
                'Required parameter "mappingId" was null or undefined when calling assetSubsystemComponentClassComponentTypeControllerUpdateMapping().'
            );
        }

        if (requestParameters['createAssetTypeSubsystemComponentClassComponentTypeRequestDto'] == null) {
            throw new runtime.RequiredError(
                'createAssetTypeSubsystemComponentClassComponentTypeRequestDto',
                'Required parameter "createAssetTypeSubsystemComponentClassComponentTypeRequestDto" was null or undefined when calling assetSubsystemComponentClassComponentTypeControllerUpdateMapping().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/asset-subsystem-componentclass-component-type/{mappingId}/component-classes`;
        urlPath = urlPath.replace(`{${"mappingId"}}`, encodeURIComponent(String(requestParameters['mappingId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateAssetTypeSubsystemComponentClassComponentTypeRequestDtoToJSON(requestParameters['createAssetTypeSubsystemComponentClassComponentTypeRequestDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async assetSubsystemComponentClassComponentTypeControllerUpdateMapping(requestParameters: AssetSubsystemComponentClassComponentTypeControllerUpdateMappingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.assetSubsystemComponentClassComponentTypeControllerUpdateMappingRaw(requestParameters, initOverrides);
    }

}
